import { ArrowButtons, Breakpoints, BreakpointWrapper, Container, ContainerGutter, DesignTokenSizeEnum, Gallery, GallerySlide, Image, Layout, styled, Text, TextAlignment, TextTag, TokenTextAppearance } from "@volkswagen-onehub/components-core";
import React, { useEffect } from "react";


const GalleryHeadline = styled(Text)`
	text-wrap: pretty !important;
	text-wrap: balance !important;
`;
const InlineImg = styled.span`
    display: inline-flex;
    align-items: center;
	padding: 0 0.25em;
	@media (max-width: ${Breakpoints.b960}px) {
		display: flex;
		justify-content: center;
		margin: 2px 0 0 0 !important;
		padding: 0.25em !important;
	}
	height: calc(clamp(2rem, 1.28rem + 2.06vw, 3.75rem));
    line-height: 1;
    overflow: hidden;
    vertical-align: middle;
	margin-top: -0.2em;
    img {
        height: calc(clamp(2rem, 1.28rem + 2.06vw, 3.75rem) * 1.7);
        width: auto;
        display: block;
    }
`;
const GalleryWrapper = styled.div`
	background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIyIiBoZWlnaHQ9IjEwNiIgdmlld0JveD0iMCAwIDMyMiAxMDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF82M180MSkiPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9mXzYzXzQxKSI+CjxlbGxpcHNlIGN4PSIxNTcuMDQiIGN5PSI1My4wMDY1IiByeD0iMTgwLjQ5NyIgcnk9IjEzLjI1MTciIGZpbGw9IiNDOTAwMTAiLz4KPC9nPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2ZfNjNfNDEiIHg9Ii01My45MjA2IiB5PSI5LjI5MTMxIiB3aWR0aD0iNDIxLjkyIiBoZWlnaHQ9Ijg3LjQzMDEiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMTUuMjMxOCIgcmVzdWx0PSJlZmZlY3QxX2ZvcmVncm91bmRCbHVyXzYzXzQxIi8+CjwvZmlsdGVyPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzYzXzQxIj4KPHJlY3Qgd2lkdGg9IjMyMiIgaGVpZ2h0PSIxMDUuODYxIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=);
	background-repeat: no-repeat;
	background-size: cover;
	padding-top: var(--size-${DesignTokenSizeEnum.dynamic0250});
	section#slider {
		padding: 0 var(--size-${DesignTokenSizeEnum.grid001});
	}
`;
const ArrowButtonsWrapper = styled.div`
	> div {
		padding: 0 calc(var(--size-${DesignTokenSizeEnum.grid001}) / 2 - 22px) !important;
	}
	button {
		background: none !important;
	}
	button * {
		display: none !important;
	}
	button::after {
		content: "";
		display: block;
		width: 15px;
		height: 30px;
		@media (min-width: ${Breakpoints.b1280}px) {
				width: 20px;
				height: 40px;
		}
		background-repeat: no-repeat;
		background-size: contain;
	}
	button:first-of-type::after {
		/* Arrow left */
		background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCAyMyA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjcxNzggMS40NDZMMi45MDA3NyAyMC40MDNDMS43NDA3NyAyMS40ODggMS41NjA3NyAyMS44ODUgMi44OTQ3NyAyMy4xMzVMMjIuNzE2OCA0Mi4wNDdMMjEuMzM1OCA0My40OTRMMS41MTk3NyAyNC41ODhDMS4wODA1NCAyNC4yNDgxIDAuNzE4MDgxIDIzLjgxOTIgMC40NTYxMzggMjMuMzI5NEMwLjE5NDE5NCAyMi44Mzk2IDAuMDM4Njc2MiAyMi4zIC0wLjAwMDIyOTgzMiAyMS43NDZDMC4wNDE4NTAxIDIxLjE5ODQgMC4xOTk2MjYgMjAuNjY1OSAwLjQ2MjY3NiAyMC4xODM4QzAuNzI1NzI2IDE5LjcwMTYgMS4wODgwNyAxOS4yODA4IDEuNTI1NzcgMTguOTQ5TDIxLjMzNTggLTYuMDQwOTFlLTA4TDIyLjcxNzggMS40NDZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K);
	}
	button:last-of-type::after {
		/* Arrow right */
		background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCAyMyA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNzI0MzRlLTA4IDQyLjA0OEwxOS44MTcgMjMuMDkxQzIwLjk3NyAyMi4wMDYgMjEuMTU3IDIxLjYwOSAxOS44MjMgMjAuMzU5TDAuMDAxMDAwOTEgMS40NDcwMkwxLjM4MiAxLjkwOWUtMDVMMjEuMTk4IDE4LjkwNkMyMS42MzcyIDE5LjI0NiAyMS45OTk3IDE5LjY3NDkgMjIuMjYxNiAyMC4xNjQ2QzIyLjUyMzYgMjAuNjU0NCAyMi42NzkxIDIxLjE5NCAyMi43MTggMjEuNzQ4QzIyLjY3NTkgMjIuMjk1NiAyMi41MTgxIDIyLjgyODEgMjIuMjU1MSAyMy4zMTAyQzIxLjk5MiAyMy43OTI0IDIxLjYyOTcgMjQuMjEzMiAyMS4xOTIgMjQuNTQ1TDEuMzgyIDQzLjQ5NEwxLjcyNDM0ZS0wOCA0Mi4wNDhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K);
	}
`;

const images = [
	'https://assets.volkswagen.com/is/image/volkswagenag/slide_01?Zml0PWNyb3AlMkMxJndpZD0xNTg0JmhlaT0xNTg0JmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJjJmYWE=',
	'https://assets.volkswagen.com/is/image/volkswagenag/slide_02?Zml0PWNyb3AlMkMxJndpZD0xNTg0JmhlaT0xNTg0JmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJjJmYWE=',
	'https://assets.volkswagen.com/is/image/volkswagenag/slide_03?Zml0PWNyb3AlMkMxJndpZD0xNTg0JmhlaT0xNTg0JmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJjJmYWE=',
	'https://assets.volkswagen.com/is/image/volkswagenag/slide_04?Zml0PWNyb3AlMkMxJndpZD0xNTg0JmhlaT0xNTg0JmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJjJmYWE=',
	'https://assets.volkswagen.com/is/image/volkswagenag/slide_05?Zml0PWNyb3AlMkMxJndpZD0xNTg0JmhlaT0xNTg0JmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJjJmYWE=',
	'https://assets.volkswagen.com/is/image/volkswagenag/slide_06?Zml0PWNyb3AlMkMxJndpZD0xNTg0JmhlaT0xNTg0JmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJjJmYWE=',
];

export function GallerySection() {
	// Añadir type=button al slider para evitar submit del form
	useEffect(() => {
		const interval = setInterval(() => {
			const slider = document.getElementById('slider');
			if (!slider) return;

			const buttons = slider.querySelectorAll('button');
			if (buttons.length === 0) return;

			buttons.forEach((btn) => btn.setAttribute('type', 'button'));

			clearInterval(interval);
		}, 50);

		return () => clearInterval(interval);
	}, []);


	return (
		<React.Fragment>
			<Layout appearance={{
				[Breakpoints.default]: [
					{ name: '.', columns: 2 },
					{ name: 'title', columns: 20 },
					{ name: '.', columns: 2 },
					{ name: 'gallery', columns: 24 }
				], [Breakpoints.b1280]: [
					{ name: '.', columns: 4 },
					{ name: 'title', columns: 16 },
					{ name: '.', columns:4 },
					{ name: 'gallery', columns: 24 }
				],
			}}>
				<GalleryHeadline
					tag={TextTag.h2} appearance={ TokenTextAppearance.headline500 } bold
					textAlign={ TextAlignment.center }
				>
					Dale las gracias a
					<BreakpointWrapper min={Breakpoints.b960}>
						<InlineImg className={TokenTextAppearance.headline500}>
							<img src="https://vgedonehubappsstaweupro.blob.core.windows.net/storage/navidad-gti-2025/text_anim.gif" />
						</InlineImg>
						<br />
					</BreakpointWrapper>
					<BreakpointWrapper max={Breakpoints.b960}>
						<InlineImg className={TokenTextAppearance.headline500}>
							<img src="https://vgedonehubappsstaweupro.blob.core.windows.net/storage/navidad-gti-2025/m_text_anim.gif" />
						</InlineImg>
					</BreakpointWrapper>
					por desearte nuestro Golf más irreverente
				</GalleryHeadline>
				<GalleryWrapper>
					<Gallery
						id="slider"
						bottomElements={
							<ArrowButtonsWrapper>
								<ArrowButtons buttonPreviousAriaLabel="<" buttonNextAriaLabel=">" />
							</ArrowButtonsWrapper>
						}
						ariaLabel=""
						endlessScrolling
						slidesPerPage={{ [Breakpoints.default]: 1, [Breakpoints.b960]: 2, [Breakpoints.b1280]: 3 }}
						gutter={ContainerGutter.dynamic0200}
					>
						{images.map((url, i) => (
							<GallerySlide key={url} ariaLabelledby={`slide${i}-heading`}>
								<Container wrap={'never'}>
									<Image alt="" src={url} />
								</Container>
							</GallerySlide>
						))}
					</Gallery>
				</GalleryWrapper>

			</Layout>
		</React.Fragment>
	)
}